import { IconButton } from "@appretio/ui-kit";
import { useState } from "react";
import { CubeOperationModal } from "./CubeOperationModal";

interface CubeOperationProps {
  /**
   * Selected cube ID for mismatch display.
   */
  selectedCubeId?: string;
  /**
   * Tooltip text and accessible label for the info button.
   */
  label: string;
}

export function CubeOperation({ selectedCubeId, label }: CubeOperationProps) {
  const [open, setOpen] = useState(false);

  if (!selectedCubeId) {
    return null;
  }

  return (
    <>
      <IconButton
        variant="tertiary"
        size="xs"
        iconName="info"
        title={label}
        aria-label={label}
        onClick={() => setOpen(true)}
      />
      <CubeOperationModal
        isOpen={open}
        onClose={() => setOpen(false)}
        selectedCubeId={selectedCubeId}
      />
    </>
  );
}
